import React, { Component } from 'react';
import InputDetails from "./InputDetails";
import {ClipLoader} from "react-spinners";

class InputAndProcess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            discogsUserName: null,
            discogsData: [],
            pollingDiscogsForData:false,
            discogsPages:1,
            currentDiscogsPage:0,

            spotifyPlaylistName: null,
            spotifyPlaylistData: null,
            currentSpotifyPosition:0,
            spotifyCount:1,

            spotifyAlbumArt: [],
            spotifyAlbumsNotFound:[],

            currentlyAdding:null,
            complete:false
        }
    }

    sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    setUsernameAndDownloadData(username){
        this.setState({discogsUserName: username})
        this.getDiscogsCollectionByUserName(username, 1);
    }

    getDiscogsCollectionByUserName(username, page){
        this.setState({pollingDiscogsForData:true})
        let url = `https://api.discogs.com/users/${username}/collection/folders/0/releases?per_page=200&page=${page}`
        fetch(url)
            .then((res)=>{return res.json()})
            .then((data)=>{
                let newData = this.state.discogsData.concat(data.releases)
                this.setState({discogsData:newData})
                if(data.pagination.page < data.pagination.pages) {
                    this.setState({currentDiscogsPage: data.pagination.page, discogsPages: data.pagination.pages})
                    this.getDiscogsCollectionByUserName(username, data.pagination.page + 1)
                }else{
                    this.setState({pollingDiscogsForData:false})
                }
            })
    }

    setPlaylistnameAndCreate(name){
        this.setState({spotifyPlaylistName: name})
        this.createSpotifyPlaylist(name);
    }

    createSpotifyPlaylist(name){
        let url = `https://api.spotify.com/v1/users/${this.props.id}/playlists`
        let body = {
            "name": name,
            "description": "Discogs Collection to Spotify",
            "public": true
        }
        let headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + this.props.token
        }
        fetch(url, {
            method: 'post',
            body: JSON.stringify(body),
            headers: headers
        }).then((r) => {
            return r.json()
        }).then((data)=>{
            this.setState({spotifyPlaylistData: data})
            this.populatePlaylist(data.id, headers, this.state.discogsData)
        })
    }

    processString(word){
        return word
            .toLowerCase()
            .split('(')[0]
            .split('-')[0]
            .replace('the ','')
            .replace('&','')
            .replace('?','')
            .replace('/','')
            .replace('\'','');

    }

    async populatePlaylist(playlistId, headers, discogsData) {
        let count = 0;
        this.setState({currentSpotifyPosition: count, spotifyCount:discogsData.length})
        for (const release of discogsData) {
            count = count + 1
            this.setState({currentSpotifyPosition: count})
            let title = release.basic_information.title
            let artist = release.basic_information.artists[0].name

            let qTitle = this.processString(title)
            let qArtist = this.processString(artist)

            let searchUrl = `https://api.spotify.com/v1/search?q=album%3A${qTitle}%20artist%3A${qArtist}&type=album`
            let spotifyResult = await fetch(searchUrl, {
                headers : headers
            })
            let res = await spotifyResult.json()

            let albumId = res.albums && res.albums.items[0] && res.albums.items[0].id;
            if(albumId){
                let artUrl = res.albums && res.albums.items[0] && res.albums.items[0].images[0].url;

                let titleProcessing = title + " - " + artist;
                let newList = [...this.state.spotifyAlbumArt, artUrl]
                this.setState({spotifyAlbumArt:newList, currentlyAdding:titleProcessing})

                let tracksUrl = `https://api.spotify.com/v1/albums/${albumId}/tracks`
                let tracksResult = await fetch(tracksUrl, {
                    headers : headers
                })
                let tracksRes = await tracksResult.json();

                await this.sleep(500)

                this.addToPlaylist(playlistId, tracksRes.items, headers)
            }
            else{
                let titleNotFound = title + " - " + artist;
                let newList = [...this.state.spotifyAlbumsNotFound, titleNotFound]
                this.setState({spotifyAlbumsNotFound:newList})
            }
        }
        this.setState({complete:true})
    }

    addToPlaylist(playlistId, albumTracks, headers){
        if (!albumTracks) return;

        let urisString = "";
        albumTracks.forEach((track)=>{
            urisString += 'spotify:track:' + track.id + ','
        })
        let url = `https://api.spotify.com/v1/playlists/${playlistId}/tracks?uris=${urisString}`
        fetch(url, {
            method: 'post',
            headers: headers
        }).then(r => r.json())
    }

    render() {
        if (!this.state.discogsUserName){
            return (
                <InputDetails
                    prompt={"Input your Discogs Username"}
                    submitText={"Next"}
                    submit={this.setUsernameAndDownloadData.bind(this)}
                />
            )
        }

        if (this.state.pollingDiscogsForData){
            let percentage = Math.round((this.state.currentDiscogsPage / this.state.discogsPages) * 100)
            return (
                <div>
                    <ClipLoader
                        size={150}
                        color={"#1db954"}
                        loading={this.state.pollingDiscogsForData}
                    />
                    <h4>Polling Discogs for your Collection</h4>
                    <p>If your collection is large, this can take a while. Don't close your browser!</p>
                    <p>As a rough estimate, if takes 2 seconds per 100 tracks.</p>
                    <p>{percentage}%</p>
                </div>
            )
        }

        if (!this.state.spotifyPlaylistName){
            return (
                <InputDetails
                    prompt={"Input a playlist name"}
                    submitText={"Go!"}
                    submit={this.setPlaylistnameAndCreate.bind(this)}
                />
            )
        }

        if(!this.state.spotifyPlaylistData){
            return <></>
        }

        let spotifyPercentage = Math.round((this.state.currentSpotifyPosition / this.state.spotifyCount) * 100)
        return (
            <div>
                <h2>
                    <a target={'_blank'} href={this.state.spotifyPlaylistData.external_urls.spotify}>
                        View playlist
                    </a>
                </h2>

                {
                    this.state.complete ?
                        <div>
                            <h4>Processing Complete</h4>
                            {/*<Donate/>*/}
                        </div>
                        :
                        <div>
                            <h4>Currently Processing...</h4>
                            <p>If your collection is large, this can take a while. Don't close your browser!</p>
                            <p>As a rough estimate, if takes 0.5 seconds per album tracks.</p>
                            <p>{spotifyPercentage}%</p>
                            <h5>{this.state.currentlyAdding}</h5>
                            {
                                this.state.spotifyAlbumArt && this.state.spotifyAlbumArt[this.state.spotifyAlbumArt.length-1] &&
                                <img
                                    src={this.state.spotifyAlbumArt[this.state.spotifyAlbumArt.length-1]}
                                    className={'currentlyProcessingImg'}
                                />
                            }
                        </div>
                }



                {
                    this.state.complete &&
                        <>
                            <div>
                                {
                                    this.state.spotifyAlbumArt.slice(0).reverse().map((imgSrc)=>{
                                        return <img src={imgSrc} style={{width:120, height:120}}/>
                                    })
                                }
                            </div>
                            <div>
                                <h4>Not Found</h4>
                                {
                                    this.state.spotifyAlbumsNotFound.map((name)=>{
                                        return <p>{name}</p>
                                    })
                                }
                            </div>
                        </>
                }
            </div>
        )
    }
}
export default InputAndProcess;